module.exports = __webpack_public_path__ + "static/media/albin.e18389ec.jpeg";